import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import { noop } from 'lodash-es'
import styled, { useTheme } from 'styled-components/native'

import { getBreakpointValue } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/theme/breakpoints'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { ShieldTriageIcon } from '../../atoms/icons/ShieldTriageIcon'
import { BodyTextSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { CareNavigatorCareOptionsFooter } from '../careNavigatorCareOptionsFooter/CareNavigatorCareOptionsFooter'

const PrivacyContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  flexDirection: 'row',
  marginBottom: theme.spacing['12px'],
  alignItems: 'center',
  marginHorizontal: getBreakpointValue(theme.breakpoints, { isMobileSized: 'auto', default: theme.spacing['0px'] }),
}))

const StyledLockedIconContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  marginRight: theme.spacing['8px'],
}))

export interface CareOptionsFooterProps {
  showPrivacy?: boolean
  onContactCareNavigatorPress?: () => void
  careNavigatorLinkTestId?: string
  careNavigatorFooterHeaderText?: React.ReactNode
}

/**
 * The shared bottom of the care-options surfaces: the care-navigator entry point banner plus the
 * confidentiality notice. Used by both Forked Triage v2 (`CareOptions`) and v3 (`CareOptionsGrid`)
 * so the banner + privacy text render identically.
 */
export const CareOptionsFooter: FunctionComponent<CareOptionsFooterProps> = ({
  showPrivacy = true,
  onContactCareNavigatorPress = noop,
  careNavigatorLinkTestId = 'CareOptionsFooter-ContactCareNavigatorLink',
  careNavigatorFooterHeaderText,
}) => {
  const { colors, isAuroraTheme } = useTheme() as ThemeType

  return (
    <>
      <CareNavigatorCareOptionsFooter
        careNavigatorLinkTestId={careNavigatorLinkTestId}
        onContactCareNavigatorPress={onContactCareNavigatorPress}
        headerText={careNavigatorFooterHeaderText}
      />
      {showPrivacy && (
        <PrivacyContainer>
          <StyledLockedIconContainer>
            <ShieldTriageIcon />
          </StyledLockedIconContainer>
          <BodyText
            text={
              <FormattedMessage
                defaultMessage='Responses are confidential'
                description='Description text explaining that responses are confidential'
              />
            }
            size={BodyTextSize.BADGE}
            textAlign='center'
            color={isAuroraTheme ? colors.textPrimary : colors.textSecondary}
            bold
          />
        </PrivacyContainer>
      )}
    </>
  )
}
